export default {
  data () {
    return {
      selectWinOpt: {
        width: '85',
        height: '60',
        top: 50,
        left: 55
      },
      flowContent: {
        top: -900,
        left: -1000,
        transformOriginX: 4000 / 2.5,
        transformOriginY: 4100 / 3.5,
        zoomSize: 1
      },
      zoomNum: 1,
      disX: '',
      disY: '',
      mainX: '',
      mainY: '',
      ifDrag: false,
      // 默认设置参数
      jsplumbSetting: {
        // 动态锚点、位置自适应
        Anchors: ['Top', 'TopCenter', 'TopRight', 'TopLeft', 'Right', 'RightMiddle', 'Bottom', 'BottomCenter',
          'BottomRight', 'BottomLeft', 'Left', 'LeftMiddle'
        ],
        Container: 'flowContent',
        // 连线的样式 StateMachine、Flowchart,有四种默认类型：Bezier（贝塞尔曲线），Straight（直线），Flowchart（流程图），State machine（状态机）
        Connector: 'Flowchart',
        // 这个是鼠标拉出来的线的属性
        ConnectionOverlays: [
          ['Label', {
            label: '下一步',
            id: 'label-1',
            cssClass: 'csslabel'
          }]
        ],
        // 鼠标不能拖动删除线
        ConnectionsDetachable: false,
        // 删除线的时候节点不删除
        DeleteEndpointsOnDetach: false,
        // 连线的端点
        // Endpoint: ["Dot", {radius: 5}],
        Endpoint: ['Rectangle', {
          height: 10,
          width: 10
        }],
        // 线端点的样式
        EndpointStyle: {
          fill: 'rgba(255,255,255,0)',
          outlineWidth: 1
        },
        LogEnabled: true, // 是否打开jsPlumb的内部日志记录
        // 绘制线
        PaintStyle: {
          stroke: 'rgb(147,147,147)',
          strokeWidth: 2
        },
        HoverPaintStyle: { stroke: 'red' },
        // 绘制箭头
        Overlays: [
          ['Arrow', {
            width: 8,
            length: 8,
            location: 1
          }]
        ],
        RenderMode: 'svg'
      },
      // jsplumb连接参数
      jsplumbConnectOptions: {
        isSource: true,
        isTarget: true,
        // 动态锚点、提供了4个方向 Continuous、AutoDefault
        anchor: 'Continuous'
      },
      jsplumbSourceOptions: {
        filter: '.flow-node-drag',  // 触发连线的区域
        /* "span"表示标签，".className"表示类，"#id"表示元素id */
        filterExclude: false,
        anchor: 'Continuous',
        allowLoopback: false
      },
      jsplumbTargetOptions: {
        filter: '.flow-node-drag',
        /* "span"表示标签，".className"表示类，"#id"表示元素id */
        filterExclude: false,
        anchor: 'Continuous',
        allowLoopback: false
      }
    }
  },
  props: {
    // 左边的 node节点
    menueList: {
      type: Array,
      default: () => []
    },
    canvasMenuStyle: {
      type: Array,
      default: () => { }
    },
    nodeList: {
      type: Array,
      default: () => { }
    },
    lineList: {
      type: Array,
      default: () => { }
    },
    loadComplete: {
      type: Boolean,
      default: false
    },
    // 编辑线条
    visableEditeLine: {
      type: Boolean,
      default: false
    },
    // 编辑节点
    visableEditeNode: {
      type: Boolean,
      default: false
    },
    // 编辑自动表单
    visableAuto: {
      type: Boolean,
      default: false
    },
    // 编辑节点
    currentElement: {
      type: Object,
      default: () => { }
    },
    // 仅读
    readerOnly: {
      type: Boolean,
      default: false
    },
    // 是否能缩放
    canZoom: {
      type: Boolean,
      default: false
    },
    // 数据格式
    dataFormat: {
      type: Object,
      default: () => {
        return {
          node: {
            sourceId: 'node_id',
            targetId: 'next_node_id',
            name: 'node_name',
            left: 'position_x',
            top: 'position_y',
            nodetype: 'node_type',
            standard: 'node_standard_code'
          },
          line: {
            lineId: 'node_result_id',
            name: 'node_result_name'
          }
        }
      }
    }
  },
  methods: {
    mousedown (e, refs) {
      let _this = this
      this.ifDrag = true
      let pos = _this.getPos(e) // 获取鼠标坐标
      _this.disX = pos.x
      _this.disY = pos.y
      _this.mainX = _this.$refs[refs].offsetLeft
      _this.mainY = _this.$refs[refs].offsetTop
      if (this.ifDrag) {
        this.mouseMove(e, refs)
      }
    },
    mouseMove (e, refs) {
      var _this = this
      setTimeout(() => {
        if (_this.ifDrag) {
          document.onmousemove = function (e) {
            var evt = window.event || e
            var left = (evt.clientX - _this.disX) + _this.mainX
            var top = (evt.clientY - _this.disY) + _this.mainY
            _this.CanMove(refs, left, top)
          }
        }
      }, 30)
      this.mouseUp()
    },
    mouseUp () {
      var _this = this
    // 鼠标抬起
      document.onmouseup = function (e) {
        if (_this.selectWinOpt.top <= 0) {
          _this.selectWinOpt.top = 0
          _this.flowContent.top = -1145
          _this.$message.warning({message: _this.$t('flow.message.top'), duration: 700})
        }
        if (_this.selectWinOpt.left <= 0) {
          _this.selectWinOpt.left = 0
          _this.flowContent.left = -1600
          _this.$message.warning({message: _this.$t('flow.message.left'), duration: 700})
        }
        if (_this.selectWinOpt.left >= 115) {
          _this.selectWinOpt.left = 115
          _this.flowContent.left = -453
          _this.$message.warning({message: _this.$t('flow.message.right'), duration: 700})
        }
        if (_this.selectWinOpt.top >= 90) {
          _this.selectWinOpt.top = 90
          _this.flowContent.top = -412
          _this.$message.warning({message: _this.$t('flow.message.bottom'), duration: 700})
        }
        document.onmousemove = null
        document.onmouseup = null
        _this.ifDrag = false
      }
    },
    changeTransformOrigin () {
      this.flowContent.transformOriginX = (5000 + this.flowContent.left) / 2.5
      this.flowContent.transformOriginY = (5000 + this.flowContent.top) / 3.5
    },
    zoomSize (e) {
      // 是否支持缩放
      if (!this.canZoom) {
        return
      }
      if (e.wheelDelta > 0 && this.flowContent.zoomSize <= 1) {
        this.flowContent.zoomSize += 0.05
      } else if (e.wheelDelta < 0 && this.flowContent.zoomSize >= 0.4) {
        this.flowContent.zoomSize -= 0.05
      }
    },
    // 判断是否能够移动
    CanMove (refs, left, top) {
      let temLeft = this.selectWinOpt.left
      let temTop = this.selectWinOpt.top
      if (refs === 'selectWin') {
        if (left >= 0 && left <= 115 && left !== temLeft) {
          if (left > temLeft) {
            this.flowContent.left = (parseInt(this.flowContent.left) + (left - temLeft) * 10.295)
          } else {
            this.flowContent.left = (parseInt(this.flowContent.left) + (left - temLeft) * 10.295)
          }
          this.selectWinOpt.left = left
        }
        if (top >= 0 && top <= 90 && top !== temTop) {
          if (top > temTop) {
            this.flowContent.top = (parseInt(this.flowContent.top) + (top - (temTop - 0.1)) * 10)
          } else {
            this.flowContent.top = (parseInt(this.flowContent.top) + (top - (temTop)) * 10)
          }
          this.selectWinOpt.top = top
        }
        this.changeTransformOrigin()
      } else {
        let selectWinOptLeft = (this.flowContent.left * 0.1 + 155)
        let selectWinOptTop = (this.flowContent.top * 0.1 + 140)

        this.flowContent.left = left - 10
        this.flowContent.top = top - 10

        this.selectWinOpt.left = selectWinOptLeft
        this.selectWinOpt.top = selectWinOptTop
        this.changeTransformOrigin()
      }
    },
    getPos (ev) {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
      return {x: ev.clientX + scrollLeft, y: ev.clientY + scrollTop}
    },
    // 复制流程图
    copyFlow () {
      this.$refs.flowdesign_canvas.innerHTML = this.$refs.flowContent.innerHTML
    },
    allowDrop (event) {
      event.preventDefault()
    }
  }
}



// WEBPACK FOOTER //
// ./packages/yz-flow/lib/mixin/index.js